module.exports = __webpack_public_path__ + "img/physical-education.0ae9c660.png";